import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { Message } from 'primereact/message';

import { RecuperaContrasena } from '../login/RecuperaContrasena';

import { autenticar } from '../../servicio/ServicioAutenticacion';
import { deleteToken, deleteUsuario } from '../../servicio/ServicioManejadorToken';
import servicioObjetos from '../../servicio/ServicioObjetos';

export default class Login extends Component {
    constructor() {
        super();
        this.state = {
            errores: {},
            usuario: {},
        };
        deleteToken();
        deleteUsuario();
    }

    login = () => {
        deleteToken();
        deleteUsuario();
        let { usuario } = this.state;
        let validacion = this.validarForm(usuario);
        this.setState({ errores: validacion });
        if (servicioObjetos.esObjetoVacio(validacion)) {
            autenticar(usuario.usuario, usuario.contrasena).then(response => {
                this.props.history.push("/dif/bienvenido/nomina");
            }).catch(error => {
                this.growl.show({ severity: "error", summary: "", detail: error });
            });
        }
    };

    asignarValores = (event) => {
        servicioObjetos.asignarAtributosObjeto(event, this, false);
    };

    validarForm = (valor) => {
        const errores = {};
        if (servicioObjetos.esObjetoVacio(valor.usuario))
            errores.usuario = "El campo usuario es requerido";
        if (servicioObjetos.esObjetoVacio(valor.contrasena))
            errores.contrasena = "El campo contraseña es requerido";
        return errores;
    }

    render() {
        const { usuario, errores } = this.state;
        return (
            <div>
                <Growl ref={(el) => this.growl = el} />
                <div class="layout-wrapper layout-static layout-static-sidebar-inactive p-ripple-disabled">
                    <div class="layout-topbar clearfix">
                        <div class="topbar-left p-ml-3 p-d-flex">
                            <span style={{ justifyContent: 'left', alignItems: 'center', fontFamily: 'tuna-medium', fontSize: '2em' }}>
                                SNDIF
                            </span>
                        </div>
                    </div>
                    <div class="layout-main">
                        <div class="p-grid p-fluid">
                            <div class="p-col-12 p-lg-3"></div>
                            <div class="p-col-12 p-lg-6" style={{ paddingTop: '80px' }}>
                                <div class="card">
                                    <h1 style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', fontWeight: 'bold' }}>Consulta de Comprobante</h1>
                                    <div class="p-grid">
                                        <div class="p-col-12">
                                            <h2>
                                                Inicio de Sesión
                                            </h2>
                                            <p style={{ textAlign: 'justify' }}>
                                                Para acceder al servicio de consulta e impresión de comprobantes
                                                de pago se requiere tener a la mano los dos elementos de identificación
                                                y seguridad. Este servicio le permite visualizar, guardar e imprimir
                                                su(s) comprobante(s) de pago. La clave de seguridad es para aumentar
                                                la confidencialidad en la consulta de su nómina.
                                            </p>
                                            <div style={{ marginTop: '4%' }}>
                                                <input class="" placeholder="Usuario (CURP)" id="usuario.usuario" className={errores.usuario ? 'p-inputtext p-component' : 'p-inputtext p-component'} name="usuario.usuario" value={usuario.usuario || ""} onChange={this.asignarValores} ></input>
                                                {errores.usuario ? <div><Message severity="error" text={errores.usuario} /> </div> : null}
                                            </div>
                                            <div style={{ marginTop: '4%' }}>
                                                <input class="p-inputtext p-component p-filled" id="usuario.contrasena" className={errores.usuario ? 'p-inputtext p-component' : 'p-inputtext p-component'} name="usuario.contrasena" value={usuario.contrasena || ""} onChange={this.asignarValores} placeholder="Contraseña" type="password"/>
                                                {errores.contrasena ? <div><Message severity="error" text={errores.contrasena} /> </div> : null}
                                            </div>
                                            <div style={{ marginTop: '4%' }}>
                                                <button class="p-button p-component p-button-text-icon-left" onClick={this.login}>
                                                    <span class="pi pi-sign-in p-c p-button-icon-left" />
                                                    <span class="p-button-text p-c">
                                                        Entrar
                                                    </span>
                                                </button>
                                            </div>
                                            <h2 style={{ marginTop: '3%' }}>
                                                Recuperar Contraseña
                                            </h2>
                                            <p style={{ textAlign: 'justify' }}>
                                                En caso de olvido o extravío de la contraseña personal el usuario puede
                                                recuperarla de forma inmediata, la contraseña se enviará a la dirección
                                                de correo electrónico registrada.
                                            </p>
                                            <div style={{ marginTop: '3%' }}>
                                                <RecuperaContrasena />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}